import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DateTImeDiv from '../../atoms/Div/DateTImeDiv';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  paper: {
    height: '100%',
    background: '#f4d700',
    color: '#000000',
    textAlign: 'center',
  },
});

const TimeCard: React.FC = () => {
  const [nowTime, setnowTime] = useState<Date>(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setnowTime(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <Typography variant="h6">
        <DateTImeDiv value={nowTime} format={'YY/MM/DD HH:mm:ss'} />
      </Typography>
    </Paper>
  );
};

export default TimeCard;
